import React from 'react';
import Button from '../../Button';
import CategoryFields from './CategoryFields';
import s from './categories.module.css';

// Add a category, at the foot of the list.
//
// The fields themselves are CategoryFields, shared with the Edit Category
// drawer (#98), so both surfaces offer the whole category.

export default function CategoryForm({ draft, onChange, onAdd, busy, errors = {} }) {
  return (
    <div className={s.addBlock}>
      <div className={s.addTitle}>Add a category</div>

      <CategoryFields
        draft={draft}
        onChange={onChange}
        idPrefix="new-category"
        disabled={busy}
        errors={errors}
      />

      <div className={s.addAction}>
        <Button onClick={onAdd} loading={busy} disabled={!draft.label.trim()}>
          Add Category
        </Button>
      </div>
    </div>
  );
}
